import './App.css';

import Home from './Home/Home.jsx';

function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
